import { render, staticRenderFns } from "./BtnAcoesLote.vue?vue&type=template&id=3685a7b0"
import script from "./BtnAcoesLote.vue?vue&type=script&lang=js"
export * from "./BtnAcoesLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports